<template>
    <div class="card shadow-sm mb-5">
        <div class="card-header">
            <div class="d-flex align-items-center">
                <div class="me-2">
                <ManyAvatar :size="1" :data="user"/>
                </div>
                <div>
                <div class="d-flex align-items-center">
                    <h4 class="me-3">{{detail?.publisher?.name}}</h4>
                    <div class="d-flex align-items-center">
                        <span class="text-primary mb-1">{{detail.title}}</span>
                    </div>
                </div>
                <span>{{ format(detail?.created_at) }}</span>
                </div>
            </div>
            <div class="card-toolbar">
                <div class="d-flex align-items-center">
                    <div class="dropdown">
                        <i class="fa fa-ellipsis-v fs-2 text-primary icon_hover" data-bs-toggle="dropdown" aria-expanded="false"></i>
                        <ul class="dropdown-menu">
                            <li v-if="$can(abilities.UPDATE_PUBLICATION)" style="cursor: pointer;"><a class="dropdown-item" @click="updateFeedModal">{{ $t('feed.update') }}</a></li>
                            <li v-if="$can(abilities.DELETE_PUBLICATION)" style="cursor: pointer;"><a class="dropdown-item" @click="deleteFeedModal">{{ $t('feed.delete') }}</a></li>
                            <li v-if="$can(abilities.DOWNLOAD_FILES)" style="cursor: pointer;"><a class="dropdown-item" v-if="detail?.files?.length > 0" @click="downloadFiles">{{ $t('feed.download') }}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="file-container mb-5" v-if="detail.files?.length > 0 && $can(abilities.FILES_PUBLICATION)">
                <div class="file-item">
                    <template v-if="isImage(detail.files[0].file_url)">
                        <div class="image-wrapper">
                            <img :src="detail.files[0].file_url" alt="Image" class="thumb-image">
                            <div @click="openDetailModal" style="cursor: pointer;" :title="$t('feed.see')" v-if="detail.files.length > 1" class="file-count">+{{ detail.files.length - 1 }}</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="image-wrapper">
                            <div class="file-preview">
                                <iframe 
                                :src="detail.files[0].file_url" 
                                frameborder="0" 
                                class="file-iframe"
                                allowfullscreen>
                                </iframe>
                                <div @click="openDetailModal" style="cursor: pointer;" :title="$t('feed.see')" v-if="detail.files.length > 1" class="file-count">+{{ detail.files.length - 1 }}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="mb-5 publish_card" v-html="detail.content"></div>
            <div class="d-flex justify-content-end">
                <span>{{ detail?.comments_count }} {{ $t('feed.comments') }}</span>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
                <span @click="openDetailModal" style="cursor: pointer;"><i class="fas fa-eye fs-2 me-2"></i>{{ $t('feed.view') }}</span>
                <span @click="showComment = !showComment" style="cursor: pointer;"><i class="fas fa-comments fs-2 me-2"></i>{{ $t('feed.comment') }}</span>
                <div class="d-flex">
                    <div v-if="detail.reactions" class="d-flex dropdown">
                        <div v-for="(emoji, index) in detail.reactions" :title="$t('button.view')" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;"
                            :key="index"
                            v-html="index" 
                            class="fs-2 me-2"
                        >
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end shadow" style="max-height: 400px; overflow-y: auto; width: 250px;">
                            <li>
                                <span class="px-5 d-flex justify-content-between">
                                    <div class="d-flex" v-for="(emoji, index) in detail.reactions" :key="index">
                                        <span class="me-2 mt-1">{{ emoji?.count }}</span>
                                        <span v-html="index" class="fs-2"></span>
                                    </div>
                                </span>
                            </li>
                            <li v-for="(user, index) in detail.user_reactions" :key="index">
                                <span class="px-5 d-flex justify-content-between">
                                    <span>{{ user?.name }}</span>
                                    <span v-html="user?.type" class="fs-2"></span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center align-items-center card shadow-sm px-2" style="width: 30px; height: 30px;">
                        <div class="dropdown" :title="$t('feed.react')">
                            <div data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
                                <i class="fas fa-smile text-yellow fs-2"></i>
                            </div>
                            <ul class="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                    <a class="dropdown-item" href="#">
                                        <span class="me-3 fs-2" :title="emoji[locale]" @click="selectEmoji(emoji.value)" v-for="(emoji, index) in emojis" :key="index" v-html="emoji.value"></span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-if="detail.mentions?.length > 0" class="d-flex justify-content-center align-items-center card shadow-sm px-2 ms-3" style="width: 30px; height: 30px;">
                        <div :title="$t('feed.mentions')" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
                            <i class="fas fa-users fs-2"></i>
                        </div>
                        <ul class="dropdown-menu dropdown-menu-end shadow mt-2" style="max-height: 300px; overflow-y: auto; width: 150px;">
                            <li v-for="(user, index) in detail.mentions" :key="index">
                                <span class="px-5">
                                    {{ user?.name }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-if="$can(abilities.VIEW_COMMENT) && showComment" class="border-top pt-5 mt-5">
                <Comment :detail="detail" :emojis="emojis" :project="project"/>
            </div>
        </div>
    </div>

    <DetailPublish :id="'detail_publish_modal'+id" :detail="detailData" :emojis="emojis" :project="project"/>
    <UpdatePublish :id="'update_publish_modal_'+id" :edit="true" @load="loadData" :user="detail?.publisher" :form="formUpdate"/>
</template>

<script setup>
    import {useStore} from "vuex";
    import {computed, ref} from "vue";
    import ManyAvatar from "@/components/ManyAvatar";
    import DetailPublish from "../modals/DetailPublish.vue"
    import Comment from "./Comment.vue"
    import {formatDistance} from "date-fns";
    import {fr} from "date-fns/locale";
    import {useLocales} from "@/composables/locales";
    import abilities from "@/composables/abilities";
    import UpdatePublish from "../modals/CreatePublish.vue"
    import {useSwal} from "@/composables/useSwal";
    import { useI18n } from 'vue-i18n'

    const emits = defineEmits(["loadFeeds"]);

    const store = useStore()
    const {locale} = useLocales()
    const {showSwal} = useSwal()
    const { t } = useI18n({ useScope: 'global' })

    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        detail: {
            type: Object,
            default: {}
        },
        project: {
            type: Object,
            default: {}
        }
    })
    const detailData = ref(props.detail)
    const showComment = ref(false)
    const nowDate = ref(new Date())
    const formUpdate = ref({
        id: '',
        title: '',
        content: '',
        is_private: false,
        story_group_id: '',
        files: [],
        attach_files: [],
        detach_files: [],
        mention_ids: [],
        model: "project",
        model_id: "",
        latitude: 0,
        longitude: 0,
        location_name: '',
        address: ''
    })

    const user = computed(() => {
        let data = props.detail || detailData.value
        let fullname = data?.publisher?.name?.split(' ')
        return fullname ? [{firstname: fullname[0], lastname: fullname[1]}] : []
    })
    const emojis = computed(() => store.getters['feeds/getReactions'])

    function format(date){
        return date ? formatDistance(new Date(date), nowDate.value, { locale: fr}) : ''
    }
  
    function openDetailModal() {
        showDetail()
    }

    function downloadFiles() {
        store.dispatch('feeds/downloadFeedFile', props.detail?.id).then(() => {
            window.toastr['success'](i18n.global.t('feed.downloaded_successfully'))
        })
    }

    function selectEmoji(item) {
        store.dispatch('feeds/createFeedReaction', {type: item, model: "PUBLICATION", model_id: props.detail?.id})
    }

    function isImage(url) {
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    }

    async function updateFeedModal() {
        await store.dispatch('feeds/showFeed', {publication_id: props.detail?.id}).then((res) => {
            let data = res.data?.data
            let mentions = data?.mentions?.map(item => item.user_id)
            formUpdate.value.id = data?.id
            formUpdate.value.title = data?.title
            formUpdate.value.content = data?.content
            formUpdate.value.is_private = data?.is_private
            formUpdate.value.files = []
            formUpdate.value.attach_files = data?.files
            formUpdate.value.mention_ids = mentions || []
            formUpdate.value.story_group_id = data?.story_group_id
            formUpdate.value.model = "project"
            formUpdate.value.latitude = parseFloat(data?.latitude) || 0
            formUpdate.value.longitude = parseFloat(data?.longitude) || 0
            formUpdate.value.location_name = data?.location_name || ''
            formUpdate.value.address = data?.address || ''

            $('#update_publish_modal_'+props.id).modal('toggle')
        })
    }

    function deleteFeedModal() {
        showSwal(
            t('feed.suppression'),
            t('feed.delete_text')
        ).then( async (result) => {
            if (result.value) {
            try {
                store.dispatch('feeds/deleteFeed', props.detail?.id)
                .then(() => {
                    emits('load')
                    window.toastr['success'](i18n.global.t('feed.deleted_successfully'))
                })
            } catch (e) {
            }
            }
        });
    }

    async function showDetail() {
        await store.dispatch('feeds/showFeed', {publication_id: props.detail?.id}).then((res) => {
            detailData.value = res.data?.data
            if(detailData.value) $('#detail_publish_modal' + props.id).modal('toggle')
        })
    }

    function loadData() {
        emits('loadFeeds')
    }

</script>

<style scoped>
    .publish_card {
        height: auto !important;
    }
    .icon_hover:hover {
        background-color: var(--bs-light-primary);
        padding: 5px 10px;
        border-radius: 5px;
    }
    .text-yellow {
        color: var(--bs-yellow) !important;
    }
    .image-wrapper {
        position: relative;
    }

    .file-container {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        width: 100%;
        justify-content: center;
    }

    .file-item {
        position: relative;
        background-color: #f1f1f1;
        border-radius: 8px;
        overflow: hidden;
        text-align: center;
    }

    .thumb-image {
        width: 80%;
        height: 80%;
        object-fit: cover;
        transition: transform 0.3s ease;
    }

    .thumb-image:hover {
        transform: scale(1.05);
    }

    .file-preview {
        width: 100%;
        height: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .file-iframe {
        width: 600px;
        height: 100%;
        border: none;
        border-radius: 8px;
    }

    .file-count {
        position: absolute;
        top: 8px;
        right: 8px;
        background-color: rgba(0, 0, 0, 0.6);
        color: white;
        padding: 2px 6px;
        border-radius: 20%;
        font-size: 12px;
    }
</style>